export default "__VITE_ASSET__bxoSm6Jf__ 100w";